import { getFunctions, httpsCallable } from '@firebase/functions';
import { app } from './firebase';
import type { GenerateReportResult } from '../types/api';

export type { GenerateReportResult } from '../types/api';

/**
 * Request a stakeholder report for a structure. Delegates to the
 * `generateStructureReport` callable function, which writes a `reports/{id}`
 * doc and (once wired to an email extension) dispatches to stakeholders.
 *
 * Email delivery is stubbed for MVP — the report doc is the source of truth
 * and the email trigger is queued for the Firebase "Trigger Email" extension.
 */
export const reportsApi = {
  async generateStructureReport(structureId: string): Promise<GenerateReportResult> {
    const functions = getFunctions(app);
    const fn = httpsCallable<{ structureId: string }, GenerateReportResult>(
      functions,
      'generateStructureReport'
    );
    const { data } = await fn({ structureId });
    return data;
  },
};
